import React from 'react'

const SupplierTicket = () => {
  return (
    <section className="section dashboard">

      {/* Filter Card */}
      <div className="row mb-3">
        <div className="col-lg-12">
          <div className="card border-0 shadow-sm" style={{ borderRadius: "16px" }}>
            <div className="card-body p-3">

              {/* Row 1 */}
              <div className="row g-2 align-items-end mb-2">
                {[
                  { id: "ddlSupplier", label: "Supplier", icon: "bi-truck", type: "select", options: [{ v: "", l: "Select Supplier" }, { v: "krishna", l: "Krishna" }] },
                  { id: "txtFromDate", label: "From Date", icon: "bi-calendar-event", type: "date" },
                  { id: "txtToDate", label: "To Date", icon: "bi-calendar-check", type: "date" },
                  { id: "txtPnr", label: "PNR", icon: "bi-qr-code", type: "text" },
                  { id: "txtOrderId", label: "Order ID", icon: "bi-receipt", type: "text" },
                ].map(({ id, label, icon, type, options }) => (
                  <div className="col-md" key={id}>
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#475569", textTransform: "uppercase", letterSpacing: "0.6px" }}>{label}</label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text" style={{ background: "#e6f1f8", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                        <i className={`bi ${icon}`} style={{ color: "var(--btn-bg)", fontSize: "12px" }}></i>
                      </span>
                      {type === "select" ? (
                        <select className="form-select form-select-sm" id={id}
                          style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "#f8f9fe", fontSize: "13px" }}>
                          {options.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                        </select>
                      ) : (
                        <input type={type} className="form-control form-control-sm" id={id} placeholder={label}
                          style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "#f8f9fe", fontSize: "13px" }} />
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Row 2 */}
              <div className="row g-2 align-items-end">
                {[
                  { id: "ddlAgencyName", label: "Agency Name", icon: "bi-building", type: "select", options: [{ v: "", l: "Select Agency" }, { v: "HGD45645", l: "Tej (HGD45645)" }] },
                  { id: "txtPaxMobile", label: "Pax Mobile", icon: "bi-phone", type: "text" },
                  { id: "txtTicketNumber", label: "Ticket Number", icon: "bi-ticket-perforated", type: "text" },
                  { id: "ddlTicketStatus", label: "Ticket Status", icon: "bi-patch-check", type: "select", options: [{ v: "", l: "Select Status" }, { v: "Ticketed", l: "Ticketed" }, { v: "Hold", l: "Hold" }, { v: "Rejected", l: "Rejected" }] },
                ].map(({ id, label, icon, type, options }) => (
                  <div className="col-md" key={id}>
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#475569", textTransform: "uppercase", letterSpacing: "0.6px" }}>{label}</label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text" style={{ background: "#e6f1f8", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                        <i className={`bi ${icon}`} style={{ color: "var(--btn-bg)", fontSize: "12px" }}></i>
                      </span>
                      {type === "select" ? (
                        <select className="form-select form-select-sm" id={id}
                          style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "#f8f9fe", fontSize: "13px" }}>
                          {options.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                        </select>
                      ) : (
                        <input type={type} className="form-control form-control-sm" id={id} placeholder={label}
                          style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "#f8f9fe", fontSize: "13px" }} />
                      )}
                    </div>
                  </div>
                ))}

                {/* Airlines - full select kept intact */}
                <div className="col-md">
                  <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#475569", textTransform: "uppercase", letterSpacing: "0.6px" }}>Airlines</label>
                  <div className="input-group input-group-sm">
                    <span className="input-group-text" style={{ background: "#e6f1f8", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                      <i className="bi bi-airplane" style={{ color: "var(--btn-bg)", fontSize: "12px" }}></i>
                    </span>
                    <select className="form-select form-select-sm" id="ddlAirlines"
                      style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "#f8f9fe", fontSize: "13px" }}>
                      <option value="">Select Airline</option>
                      <option value="2T">TruJet(2T)</option><option value="3K">JETSTAR ASIA(3K)</option>
                      <option value="6E">Indigo(6E)</option><option value="AI">Air India(AI)</option>
                      <option value="AK">Air Asia(AK)</option><option value="BA">British Airways(BA)</option>
                      <option value="EK">Emirates(EK)</option><option value="EY">Etihad Airways(EY)</option>
                      <option value="G8">GoAir(G8)</option><option value="I5">Air Asia India(I5)</option>
                      <option value="IX">AirIndia Express(IX)</option><option value="LH">Lufthansa(LH)</option>
                      <option value="QR">Qatar Airways(QR)</option><option value="SG">Spicejet(SG)</option>
                      <option value="SQ">Singapore Air(SQ)</option><option value="TK">Turkish Airlines(TK)</option>
                      <option value="UK">Vistara(UK)</option><option value="VS">Virgin Atlantic(VS)</option>
                    </select>
                  </div>
                </div>

                {/* Buttons */}
                <div className="col-md-2 d-flex gap-2">
                  <button type="submit" className="btn btn-sm text-white fw-semibold flex-grow-1 d-flex align-items-center justify-content-center gap-1"
                    style={{
                      background: "linear-gradient(135deg, var(--btn-hover-bg) 0%, var(--btn-bg) 100%)",
                      borderRadius: "8px", border: "none",
                      boxShadow: "0 3px 10px rgba(14,106,150,0.25)",
                      fontSize: "13px", height: "34px"
                    }}>
                    <i className="fa-solid fa-magnifying-glass"></i> Search
                  </button>
                  <button type="button" className="btn btn-sm d-flex align-items-center justify-content-center gap-1 px-3"
                    style={{
                      background: "#f0f4f8", border: "1.5px solid #dde3ef",
                      borderRadius: "8px", color: "#4a5568",
                      fontSize: "13px", height: "34px", whiteSpace: "nowrap"
                    }}>
                    <i className="fa-solid fa-cloud-arrow-down"></i> Export
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="row">
        <div className="col-lg-12">
          <div className="card border-0 shadow-sm" style={{ borderRadius: "16px", overflow: "hidden" }}>
            <div className="card-body pb-0 p-3">

              {/* Table Header */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center gap-2">
                  <div style={{
                    width: "32px", height: "32px", borderRadius: "8px",
                    background: "linear-gradient(135deg, var(--btn-hover-bg) 0%, var(--btn-bg) 100%)",
                    display: "flex", alignItems: "center", justifyContent: "center"
                  }}>
                    <i className="bi bi-ticket-perforated-fill text-white" style={{ fontSize: "14px" }}></i>
                  </div>
                  <div>
                    <span className="fw-bold" style={{ color: "#2d3748", fontSize: "15px" }}>Supplier Tickets</span>
                    <span className="ms-2 badge rounded-pill" style={{ background: "#e6f1f8", color: "var(--btn-bg)", fontSize: "11px", fontWeight: "600" }}>
                      123 Records
                    </span>
                  </div>
                </div>
              </div>

              {/* Table */}
              <div className="table-responsive" style={{ height: "calc(100vh - 380px)" }}>
                <table className="table table-hover mb-0" style={{ fontSize: "12px" }}>
                  <thead>
                    <tr style={{ background: "#f8f9fe" }}>
                      {["Order ID", "Invoice No", "Supplier", "Sup. Mob", "Sup. Email", "Agency", "Agency Mob", "Agency Email", "Pax Mob", "PNR", "Ticket No", "Pax Name", "Airline", "Sector", "Booked Date", "Journey Date", "Base Fare", "Other Tax", "Total"].map((h, i) => (
                        <th key={i} style={{
                          fontSize: "10px", fontWeight: "700", color: "#475569",
                          textTransform: "uppercase", letterSpacing: "0.5px",
                          borderBottom: "2px solid #e8edf5", padding: "9px 10px",
                          whiteSpace: "nowrap", background: "#f8f9fe"
                        }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {[1, 2].map((_, index) => (
                      <tr key={index}
                        style={{ borderBottom: "1px solid #f0f4f8", transition: "background 0.15s" }}
                        onMouseEnter={e => e.currentTarget.style.background = "#f8f9fe"}
                        onMouseLeave={e => e.currentTarget.style.background = "white"}
                      >
                        <td style={{ padding: "9px 10px" }}>
                          <span className="badge" style={{ background: "#e6f1f8", color: "var(--btn-bg)", fontWeight: "600", fontSize: "11px" }}>Krishna Kant</span>
                        </td>
                        <td style={{ padding: "9px 10px", fontFamily: "monospace", fontSize: "11px", color: "#4a5568" }}>KKK0000220</td>
                        <td style={{ padding: "9px 10px", fontWeight: "600", color: "#2d3748" }}>999999999</td>
                        <td style={{ padding: "9px 10px", color: "#4a5568" }}>kk@gmail.com</td>
                        <td style={{ padding: "9px 10px", color: "#4a5568", maxWidth: "120px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>Uttam nagar</td>
                        <td style={{ padding: "9px 10px", color: "#4a5568" }}>Uttam nagar</td>
                        <td style={{ padding: "9px 10px", color: "#4a5568" }}>Delhi</td>
                        <td style={{ padding: "9px 10px", color: "#4a5568" }}>Tej Singh</td>
                        <td style={{ padding: "9px 10px", color: "#4a5568" }}>3/29/2025</td>
                        <td style={{ padding: "9px 10px" }}>
                          <span className="badge" style={{ background: "#f0fff4", color: "#38a169", border: "1px solid #c6f6d5", fontSize: "11px", fontWeight: "600" }}>20000</span>
                        </td>
                        <td style={{ padding: "9px 10px", fontFamily: "monospace", fontSize: "11px", color: "#4a5568" }}>KKK0000220</td>
                        <td style={{ padding: "9px 10px", fontWeight: "600", color: "#2d3748" }}>999999999</td>
                        <td style={{ padding: "9px 10px", color: "#4a5568" }}>kk@gmail.com</td>
                        <td style={{ padding: "9px 10px", color: "#4a5568" }}>Uttam nagar</td>
                        <td style={{ padding: "9px 10px", color: "#4b5563", whiteSpace: "nowrap", fontSize: "11px" }}>Uttam nagar</td>
                        <td style={{ padding: "9px 10px", color: "#4b5563", whiteSpace: "nowrap", fontSize: "11px" }}>Delhi</td>
                        <td style={{ padding: "9px 10px", fontWeight: "600", color: "#4a5568" }}>₹ Tej Singh</td>
                        <td style={{ padding: "9px 10px", color: "#4a5568" }}>₹ —</td>
                        <td style={{ padding: "9px 10px", fontWeight: "700", color: "var(--btn-bg)" }}>₹ 20000.00</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="table-pagination">
                <div className="dataTables_info" style={{ fontSize: "12px", color: "#475569" }} role="status">
                  Showing 11 to 18 of 18 entries
                </div>
                <div className="dataTables_paginate paging_simple_numbers">
                  <ul className="pagination mb-0" style={{ gap: "4px" }}>
                    <li className="paginate_button page-item previous">
                      <a href="javascript:void(0)" className="page-link"
                        style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", color: "var(--btn-bg)", fontSize: "13px" }}>
                        <i className="fa-solid fa-angle-left"></i>
                      </a>
                    </li>
                    <li className="paginate_button page-item">
                      <a href="javascript:void(0)" className="page-link"
                        style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px" }}>1</a>
                    </li>
                    <li className="paginate_button page-item active">
                      <a href="javascript:void(0)" className="page-link"
                        style={{ borderRadius: "8px", fontSize: "13px" }}>2</a>
                    </li>
                    <li className="paginate_button page-item next disabled">
                      <a href="javascript:void(0)" className="page-link"
                        style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", color: "var(--btn-bg)", fontSize: "13px" }}>
                        <i className="fa-solid fa-angle-right"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </section>
  )
}

export default SupplierTicket